<template>
  <vue-modal :key="refreshModal" ref="value-player-icons-list" name="value-player-icons-list" :adaptive="false" :width="398" height="auto" :scrollable="true" @before-open="onBeforeOpen" >
    <form id="ImportValuePlayerIconFormId" name="form">
        <div class="container ">
            <div class="form-group form-row p-2 justify-content-center">
                <h5 class="font-weight-bold text-center">Value Player Icons</h5>
            </div>
            <div class="form-row pt-1">
                <div class="form-group col-12">
                    <div class="row w-100 justify-content-center text-center">
                        <div class="col-6 d-flex flex-column align-items-center mb-3"
                            v-for="(valuePlayerIconOption, idxIcon) in valuePlayerIconOptions" :key="idxIcon" >
                            <div class="d-flex align-items-center justify-content-center mb-1">
                            <input type="radio" class="mr-2" :id="`playerIcon-${idxIcon}`" name="playerIcon" v-model="selectedIconObj"
                                :value="valuePlayerIconOption" />
                            <img :src="valuePlayerIconOption.imagePath" width="50" height="50" class="d-block" />
                        </div>
                        <!-- Image name -->
                        <div class="small font-weight-bold">
                            {{ valuePlayerIconOption.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group form-row pt-1 d-flex justify-content-end">
          <button type="submit" class="btn btn-primary float-right ml-2" :disabled="!selectedIconObj" @click="confirmIcon">
            <span>Select Icon</span>
            <span v-show="getModalLoading()" class="spinner-border spinner-border-sm"></span>
          </button>
          <button type="button" class="btn btn-primary ml-4" @click="closeModal">
            Close
          </button>
        </div>
      </div>
    </form>
  </vue-modal>
</template>

<script>
import ContentMixins from "../mixins/ContentMixins.vue";
import ViewMixins from "../mixins/ViewMixins.vue";

export default {
  name: "ImportValuePlayerIcon",
  components: {},
  mixins: [ContentMixins, ViewMixins],

  methods: {
    onBeforeOpen() {
        // Clear the previously selected icon each time modal opens
        this.selectedIconObj = null;
    },
    closeModal() {
      if (this.$refs['value-player-icons-list'] != null) {
        this.$refs['value-player-icons-list'].visible = false;
      }
      this.refreshModal = !this.refreshModal;
    },
    confirmIcon() {
        if (!this.selectedIconObj) return;
        this.$emit('icon-selected', {
            rowIndex: this.rowIndex,
            icon: this.selectedIconObj
        });
        this.closeModal();
    }
  },
  props: {
    rowIndex: {
      type: Number,
      required: false,
      default: null
    },
    valuePlayerIconOptions: {
        type: Array,
        required: true,
        default: () => []
    },
  },
  data() {
    return {
        selectedIconObj: null, 
        refreshModal: true
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>
